import { render, staticRenderFns } from "./TableProducts.template.vue?vue&type=template&id=3f13dea1&scoped=true&"
var script = {}
import style0 from "./TableProducts.template.vue?vue&type=style&index=0&id=3f13dea1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13dea1",
  null
  
)

export default component.exports